// Session-sticky record of organizations whose membership has been verified for
// the current subject. No TTL: per-request X-Astur-Organization enforcement is
// the backstop, and re-entering an organization triggers a background
// revalidation against the TTL-cached organization list.
let validatedSubject: string | null = null;
const validatedOrganizations = new Set<string>();

export const isOrganizationValidated = (subject: string | null, organization: string): boolean => {
  return subject !== null && subject === validatedSubject && validatedOrganizations.has(organization);
};

export const markOrganizationValidated = (subject: string | null, organization: string): void => {
  if (!subject) return;
  if (validatedSubject !== subject) {
    validatedSubject = subject;
    validatedOrganizations.clear();
  }
  validatedOrganizations.add(organization);
};

export const unmarkOrganizationValidated = (subject: string | null, organization: string): void => {
  if (subject !== validatedSubject) return;
  validatedOrganizations.delete(organization);
};

export const invalidateValidatedOrganizations = (): void => {
  validatedSubject = null;
  validatedOrganizations.clear();
};
